import axios from 'axios';

import { IPortalUserRole } from '@/shared/model/portal-user-role.model';

const baseApiUrl = 'api/portal-user-roles';
const apiGetAllByAbbreviations = 'api/portal-user-roles/abbreviations'

export default class PortalUserRoleService {
  public find(id: number): Promise<IPortalUserRole> {
    return new Promise<IPortalUserRole>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IPortalUserRole): Promise<IPortalUserRole> {
    return new Promise<IPortalUserRole>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IPortalUserRole): Promise<IPortalUserRole> {
    return new Promise<IPortalUserRole>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getAllByAbbreviations(abbreviations: string[]): Promise<IPortalUserRole[]> {
    return new Promise<IPortalUserRole[]>((resolve, reject) => {
      axios
        .get(`${apiGetAllByAbbreviations}/${abbreviations}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
